import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, InputNumber, Select } from 'antd';
import dayjs from 'dayjs';
import { Log } from '../../../Modules/Log/Model/Log';
import { actionMeta, allowedActionKeys, extractMainKey } from './helpers';

const { TextArea } = Input;
const { Option } = Select;

interface Props {
  open: boolean;
  log: Log | null;
  onClose: () => void;
  onSubmit: (payload: Partial<Pick<Log, 'action' | 'description' | 'final_days' | 'end_date' | 'total_days' | 'start_date'>>) => Promise<void>;
}

const LogEditModal: React.FC<Props> = ({ open, log, onClose, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (log) {
      const actionKey = extractMainKey(log.action) || log.action;
      form.setFieldsValue({
        action: actionKey,
        description: log.description || '',
        total_days: log.total_days || undefined,
        final_days: log.final_days || undefined,
        start_date: log.start_date ? dayjs(log.start_date) : null,
        end_date: log.end_date ? dayjs(log.end_date) : null,
      });
    } else {
      form.resetFields();
    }
  }, [log, form]);

  const handleOk = async () => {
    const v = await form.validateFields();
    const payload: any = {
      action: v.action,
      description: v.description,
      total_days: v.total_days,
      final_days: v.final_days,
      start_date: v.start_date ? v.start_date.format('YYYY-MM-DD') : undefined,
      end_date: v.end_date ? v.end_date.format('YYYY-MM-DD') : undefined,
    };
    await onSubmit(payload);
  };

  return (
    <Modal
      open={open}
      title="로그 수정"
      onOk={handleOk}
      onCancel={onClose}
      okText="저장"
      cancelText="취소"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="action" label="행위" rules={[{ required: true, message: '행위를 선택하세요' }]}>
          <Select placeholder="행위를 선택하세요">
            {Array.from(allowedActionKeys).map(key => (
              <Option key={key} value={key}>{actionMeta[key]?.label || key}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="description" label="설명">
          <TextArea rows={3} placeholder="설명을 입력하세요" />
        </Form.Item>
        <Form.Item name="total_days" label="기간">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="final_days" label="발주일수">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="start_date" label="시작일">
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item name="end_date" label="종료일">
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LogEditModal;


